<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col sm="11" lg="11" v-if="chksubmit===1">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <form id="app">
                <img class="img-fluid d-block mx-auto " src="https://reg.mfu.ac.th/verification/img/logo_300.gif" height="181" width="103"/><br>
                  <h2 class="text-center">ระบบตรวจสอบคุณวุฒิการศึกษาออนไลน์</h2>
                  <p class="text-muted text-center">เลือกภาษา | Select Language : <span style="cursor:pointer" @click="linkUrl(0)"><b><u>TH</u></b></span> 
                  | <span style="cursor:pointer" @click="linkUrl(1)"><b><u>EN</u></b></span>  </p>
                  <h4>ข้อมูลผู้ขอตรวจสอบ</h4><br>
                  <b-row>
                    <b-col>
                      <b-form-group
                        label="ชื่อหน่วยงาน :"
                        label-for="COMPANYNAME"
                        :label-cols="2"
                        :horizontal="true" 
                        :invalid-feedback="companynameInvalid"
                        :valid-feedback="companynameValid"
                      >
                        <b-form-input id="COMPANYNAME" type="text" name="COMPANYNAME"  v-model="getdata.companyname" :state="companynameState"></b-form-input>
                      </b-form-group> 

                      <b-form-group
                        label="ชื่อผู้ขอตรวจสอบ :"
                        label-for="NAME"
                        :label-cols="2"
                        :horizontal="true"
                        :invalid-feedback="nameInvalid"
                        :valid-feedback="nameValid"
                      >
                        <b-form-input id="NAME" type="text" name="NAME" v-model="getdata.name" :state="nameState"></b-form-input>
                      </b-form-group>

                      <b-form-group
                        label="นามสกุล :"
                        label-for="SURNAME"
                        :label-cols="2"
                        :horizontal="true"
                        :invalid-feedback="surnameInvalid"
                        :valid-feedback="surnameValid"
                      >
                        <b-form-input id="SURNAME" type="text" name="SURNAME" v-model="getdata.surname" :state="surnameState"></b-form-input>
                      </b-form-group>

                      <b-form-group
                        label="เบอร์โทรศัพท์ :"
                        label-for="MOBILE"
                        :label-cols="2"
                        :horizontal="true"
                        :invalid-feedback="mobileInvalid"
                        :valid-feedback="mobileValid"
                      >
                        <b-form-input id="MOBILE" type="text" name="MOBILE" v-model="getdata.mobile" :state="mobileState"></b-form-input>
                      </b-form-group>

                      <b-form-group
                        label="อีเมล :"
                        label-for="EMAIL"
                        :label-cols="2"
                        :horizontal="true"
                        :invalid-feedback="emailInvalid"
                        :valid-feedback="emailValid"
                      >
                        <b-form-input id="EMAIL" type="text" name="EMAIL" v-model="getdata.email" :state="emailState"></b-form-input>
                      </b-form-group>

                      <b-form-group
                        label="วัตถุประสงค์ :"
                        label-for="VERIFICATIONID"
                        :label-cols="2"
                        :horizontal="true"
                        :invalid-feedback="verificationInvalid"
                        :valid-feedback="verificationValid"
                      >
                        <b-form-select
                          v-model="getdata.verification.selected"
                          id="VERIFICATIONID"
                          @change="chkselect()"
                          :state="verificationState"
                        >
                          <option
                            v-for="option in getdata.verification.options"
                            v-bind:value="option.value" v-bind:key="option.value"
                          >{{ option.text }}</option>
                        </b-form-select>
                      </b-form-group>

                      <b-form-group
                        label="อื่นๆ :"
                        label-for="VERIFICATIONTEXT"
                        :label-cols="2"
                        :horizontal="true"
                        v-if="chkverification"
                        :invalid-feedback="verificationTextInvalid"
                        :valid-feedback="verificationTextValid"
                      >
                        <b-form-input id="VERIFICATIONTEXT" type="text" name="VERIFICATIONTEXT" v-model="getdata.verificationtext" :state="verificationTextState"></b-form-input>
                      </b-form-group>
                    </b-col>
                    
                  </b-row>
                  
                 
                  <b-row>
                    <b-col cols="12">
                      <hr>
                      <b-button size="lg" class="btn-login btn-lg" @click="checkForm" block>เข้าสู่ระบบ</b-button>
                    </b-col>
                    <b-col cols="12">
                      <b-button size="lg" class="btn-manual btn-lg btn-info" variant="info" @click="selectUrl" block>คู่มือการใช้งาน</b-button>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col cols="12">
                      <hr>
                      <b>หมายเหตุ :</b> 
                      <ul>
                        <li>ระบบนี้จัดทำขึ้นเพื่อให้หน่วยงานภายนอกสามารถตรวจสอบคุณวุฒิผู้สำเร็จการศึกษาจากมหาวิทยาลัยแม่ฟ้าหลวง</li>
                        <li>หากท่านต้องการตรวจสอบข้อมูลอื่นๆ นอกเหนือจากที่ปรากฏ ท่านจะต้องส่งหนังสือตรวจสอบคุณวุฒิอย่างเป็นทางการมายังมหาวิทยาลัยแม่ฟ้าหลวง</li>
                      </ul>
                    </b-col>
                    <b-col cols="12" class="text-right">
                      <br>
                      <label>ส่วนทะเบียนและประมวลผล มหาวิทยาลัยแม่ฟ้าหลวง</label>
                    </b-col>
                    <b-col cols="12" class="text-right">
                      <label>ติดต่อสอบถาม โทร. 0 5391 6547</label>
                    </b-col>
                  </b-row>
                </form>
                <!-- *********************************** -->

                <div slot="footer" class="">
                    <b-modal title="กรุณากรอกข้อมูลให้สมบูรณ์" class="modal-danger" v-model="dangerModal" @ok="dangerModal = false" ok-variant="danger">
                        <div v-if="errors.length">
                          <ul>
                              <li v-for="error in errors" v-bind:key="error">{{ error }}</li>
                          </ul>
                        </div>
                    </b-modal>
                </div>
              </b-card-body>
            </b-card>
           
          </b-card-group>
        </b-col>

        <b-col sm="12" lg="12" v-if="chksubmit===2">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-alert show variant="success">
                <h2 class="text-center">
                  คุณได้รับอีเมลจากมหาวิทยาลัยแม่ฟ้าหลวง เพื่อยืนยันข้อมูลในการใช้งาน กรุณาตรวจดูที่กล่องจดหมายหรือจดหมายขยะ
                </h2> 
              </b-alert>
            </b-card>
          </b-card-group>
        </b-col>

        <b-col sm="12" lg="12" v-if="chksubmit===3">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-alert show variant="warning">
                <h2 class="text-center">
                  กรุณารอสักครู่ ระบบกำลังทำการส่งข้อมูลไปยัง Email : {{getdata.email}}
                </h2> 
              </b-alert>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import AuthenService from "@/services/AuthenService";
import VerificationService from "@/services/VerificationService";
import BookingService from "@/services/BookingService";
import store from "@/store/store";
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import Api from '@/services/Api'

export default {
  name: 'Login',
  data: () => ({
    getdata: {
        verification : {
          selected : '0',
          options : [
            { text: 'กรุณาเลือกข้อมูล', value: '0' },
            { text: 'เพื่อตรวจสอบเข้าทำงาน', value: '1' },
            { text: 'เพื่อตรวจสอบเข้าศึกษาต่อ', value: '2' },
            { text: 'อื่นๆ', value: '3' }
          ]
        },
        companyname : '',
        name : '',
        surname : '',
        mobile : '',
        email : '',
        verificationtext : '',
    },
    errors:[],
    item_group:[],
    chkverification:false,
    dangerModal:false,
    chksubmit:1,
    username:null,
    password:null,
    items_data:[]
  }),
  mounted: function() {
    //this.savelogin();
    //this.getGroupAll(); //method1 will execute at pageload
    //this.clearlogin();
  },
  computed: {
    companynameState() {
        return this.getdata.companyname.length > 1 ? true : false
    },
    companynameInvalid() {
        if (this.getdata.companyname.length > 1) {return ''} else {return 'กรุณากรอกข้อมูลให้ถูกต้อง'}
    },
    companynameValid() {
        return this.companynameState === true ? 'Thank you' : ''
    },
    nameState() {
        return this.getdata.name.length > 1 ? true : false
    },
    nameInvalid() {
        if (this.getdata.name.length > 1) {return ''} else {return 'กรุณากรอกข้อมูลให้ถูกต้อง'}
    },
    nameValid() {
        return this.nameState === true ? 'Thank you' : ''
    },
    surnameState() {
        return this.getdata.surname.length > 1 ? true : false
    },
    surnameInvalid() {
        if (this.getdata.surname.length > 1) {return ''} else {return 'กรุณากรอกข้อมูลให้ถูกต้อง'}
    },
    surnameValid() {
        return this.surnameState === true ? 'Thank you' : ''
    },
    mobileState() {
        return this.getdata.mobile.length > 1 ? true : false
    },
    mobileInvalid() {
        if (this.getdata.mobile.length > 1) {return ''} else {return 'กรุณากรอกข้อมูลให้ถูกต้อง'}
    },
    mobileValid() {
        return this.mobileState === true ? 'Thank you' : ''
    },
    emailState() {
        if (!this.getdata.email) {
          return false
        }
        else if (!this.validEmail(this.getdata.email)) {
          return false
        }
        else{
          return true
        }
    },
    emailInvalid() {
        if (this.emailState === true) {return ''} else {return 'กรุณากรอกข้อมูลให้ถูกต้อง เพื่อยืนยันข้อมูลในขั้นตอนต่อไป'}
    },
    emailValid() {
        return this.emailState === true ? 'Thank you' : ''
    },
    verificationState() {
        return this.getdata.verification.selected > '0' ? true : false
    },
    verificationInvalid() {
        if (this.getdata.verification.selected > '0') {return ''} else {return 'กรุณากรอกข้อมูลให้ถูกต้อง'}
    },
    verificationValid() {
        return this.verificationState === true ? 'Thank you' : ''
    },
    verificationTextState() {
        if(this.getdata.verification.selected == 3){
          if(this.getdata.verificationtext.length > 1){
            return true
          }
          else{
            return false
          }
        }
        else{
          return true
        }
    },
    verificationTextInvalid() {
        if (this.verificationTextState === true) {return ''} else {return 'กรุณากรอกข้อมูลให้ถูกต้อง เพื่อยืนยันข้อมูลในขั้นตอนต่อไป'}
    },
    verificationTextValid() {
        return this.verificationTextState === true ? 'Thank you' : ''
    },
  },
  methods:{
    async checkForm(e) {
      this.errors = [];
      this.dangerModal = false;
      if(this.getdata.verification.selected != 0 && this.getdata.companyname && this.getdata.name && this.getdata.surname && this.getdata.mobile && this.getdata.email && this.validEmail(this.getdata.email)){ 

        if(this.getdata.verification.selected == 3 && !this.getdata.verificationtext) 
        {
          this.errors.push("กรุณาระบุเหตุผล วัตถุประสงค์");
        }
        else{
          this.savelogin();
        }
        
      }
      else{
        if(!this.getdata.companyname) this.errors.push("กรุณาระบุ บริษัท");
        if(!this.getdata.name) this.errors.push("กรุณาระบุ ชื่อผู้ติดต่อ");
        if(!this.getdata.surname) this.errors.push("กรุณาระบุ นามสกุลผู้ติดต่อ");
        if(!this.getdata.mobile) this.errors.push("กรุณาระบุ เบอร์โทรศัพท์");
        //if(!this.getdata.email) this.errors.push("กรุณาระบุ อีเมล");
        if(this.getdata.verification.selected == 0) this.errors.push("กรุณาระบุ วัตถุประสงค์");
        //if(this.getdata.verification.selected == 3 && !this.getdata.verificationtext) this.errors.push("กรุณาระบุเหตุผล วัตถุประสงค์");

        if (!this.getdata.email) {
          this.errors.push("กรุณาระบุ อีเมล");
        }
        else if (!this.validEmail(this.getdata.email)) {
          this.errors.push("กรุณาระบุ อีเมล ให้ถูกต้อง");
        }
        
        e.preventDefault();
      }

      if(this.errors.length > 0){
        this.dangerModal = true;
      }
      
    },
    async chkselect(){
      //*************************************** */
      this.verificationtext = null;
      this.getdata.verificationtext = "";
      //*************************************** */
      if(this.getdata.verification.selected == "3"){
        this.chkverification = true;
      }
      else{
        this.chkverification = false;
      }
      //*************************************** */
    },
    async savelogin() {
      this.chksubmit = 3;
      this.items_data = {
                          verid : this.getdata.verification.selected,
                          companyname : this.getdata.companyname,
                          name : this.getdata.name,
                          surname : this.getdata.surname,
                          mobile : this.getdata.mobile,
                          email : this.getdata.email,
                          vertext : this.getdata.verificationtext,
                          lang : "th"
                        }
      /*Api().get("companylogin")
              .then(response => {
                console.log(response);
              })
              .catch(error => {
              });*/
      //companylogin
      /*this.chksubmit = 3;
      this.items_data = {
                          verid : this.getdata.verification.selected,
                          companyname : this.getdata.companyname,
                          name : this.getdata.name,
                          surname : this.getdata.surname,
                          mobile : this.getdata.mobile,
                          email : this.getdata.email,
                          vertext : this.getdata.verificationtext,
                        }*/

      //this.chksubmit = 2;
      //console.log(this.items_data);
      const data = (await VerificationService.insertApiCompanyLogin(this.items_data));
      //console.log(data);
      //************************************************************************************ */
      if(data === 403){

      }
      else{
        this.chksubmit = 2;
      }
      //window.open('mailto:tanachai.kha@mfu.ac.th?subject=subject&body=body');
      /*try {
        const data = (await AuthenService.login(this.username, this.password))
          .data;
        if (data.status == "success") {
          this.$store.dispatch("setToken", data.token);
          this.$router.push('/dashboard');
        }
        
      }
      catch (err) {
        this.errors = [];
        this.errors.push("Username / password is incorrect")
        console.log(err.message);
      }*/
    },
    async selectUrl(){
      //window.location.href = "https://reg.mfu.ac.th/verification/download/User_Manual_TH.pdf";
      window.location.href = "https://drive.google.com/file/d/1tN-KE5r7a3oSnoRYQjmbjxpp6wWcKTjC/view?usp=sharing";
    },
    async linkUrl(e){
      if(e == 0)
      {
        this.$router.push('/pages/login')
      }
      else
      {
        this.$router.push('/pages/loginEN')
      }
      
    },
    frontFormatter(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    validEmail: function (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }
  }
}
</script>

<style>

.btn-manual{
  color: #ffffff;
    background-color: #CC9900;
    border-color: #CC9900;
    margin-bottom: 10px;
}

.btn-login {
    color: #ffffff;
    background-color: #8c1515;
    border-color: #8c1515;
    margin-bottom: 10px;
}

.wapper_detail_login {
    background-color: #8c1515;
    border: 1px #a07517 solid;
    border-radius: 0px 0px 0px 0px;
}

.wapper_detail_login_footer {
    background-color: #8c1515;
    border: 1px #a07517 solid;
    border-radius: 0px 0px 0px 0px;
}

.copyright {
    font-size: x-small;
    position: absolute;
    bottom: 0px;
    width: 100%;
    left: 0;
}
</style>
